import { makeStyles } from "@material-ui/core/styles";

export const useCommonStyles = makeStyles((theme) => ({
  reviewing: {
    color: "black", // 確認中の状態に合った色
    backgroundColor: "#a0d8ef", // 薄いオレンジの背景色（必要に応じて調整）
  },
  received: {
    color: "black", // 受領済みの状態に合った色
    backgroundColor: "#9ae69a", // 薄い緑の背景色（必要に応じて調整）
  },
  rejected: {
    color: "black", // 却下の状態に合った色
    backgroundColor: "#f19ca7", // 薄い赤の背景色（必要に応じて調整）
  },
  onHold: {
    color: "black", // 保留の状態に合った色
    backgroundColor: "#bdafdb", // 薄いグレーの背景色（必要に応じて調整）
  },
  resubmission: {
    color: "black", // 再提出の状態に合った色
    backgroundColor: "#f4a460", // 薄い青の背景色（必要に応じて調整）
  },
  scheduled: {
    color: "black", // 予定の状態に合った色
    backgroundColor: "#e0e0e0", // 薄いグレーの背景色（必要に応じて調整）
  },

  unknown: {
    color: "black", // 不明の状態に合った色
    backgroundColor: "#E0E0E0", // 薄いグレーの背景色（必要に応じて調整）
  },
}));
